module.exports = __webpack_public_path__ + "static/media/cilia.de2e2837.png";